// removed by extract-text-webpack-plugin
module.exports = {"container":"kX-TFq4EhEumXKJPx7G52","title":"dPl77VzO5GxZNEqK0kk7M"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/Templates/styles.css
// module id = 3172
// module chunks = 0